/* eslint-disable no-unused-vars */
import React from "react";
import { Box, Container, Grid, Typography, Button } from "@mui/material";
import Hero from "../components/Hero";
import ServiceCard from "../components/ServiceCard";
import TestimonialCard from "../components/TestimonialCard";
import ContactForm from "../components/ContactForm";
import ElectricBoltIcon from "@mui/icons-material/ElectricBolt";
import ConstructionIcon from "@mui/icons-material/Construction";
import HomeIcon from "@mui/icons-material/Home";
import BusinessIcon from "@mui/icons-material/Business";
import sample1 from "../assets/images/sample1.jpeg";
import sample2 from "../assets/images/sample2.jpeg";
import sample3 from "../assets/images/sample3.jpeg";
import sample4 from "../assets/images/sample4.jpeg";
import sample5 from "../assets/images/sample5.jpeg";
import sample6 from "../assets/images/sample6.jpeg";

const Home = () => {
  const services = [
    {
      title: "Residential Wiring",
      description:
        "Complete electrical wiring services for new homes, renovations, and upgrades, ensuring safety and efficiency.",
      icon: <HomeIcon fontSize="large" />,
      imageUrl: sample1,
    },
    {
      title: "Commercial Services",
      description:
        "Specialized electrical solutions for businesses, offices, and commercial properties, minimizing downtime.",
      icon: <BusinessIcon fontSize="large" />,
      imageUrl: sample2,
    },
    {
      title: "Electrical Repairs",
      description:
        "Fast and reliable repair services for all electrical issues, from outlets and switches to major electrical problems.",
      icon: <ConstructionIcon fontSize="large" />,
      imageUrl: sample3,
    },
    {
      title: "Panel Upgrades",
      description:
        "Upgrade your electrical panel to handle modern power demands safely and efficiently, preventing overloads.",
      icon: <ElectricBoltIcon fontSize="large" />,
      imageUrl: sample4,
    },
  ];

  const testimonials = [
    {
      name: "John Smith",
      role: "Homeowner",
      quote:
        "Davitt Electric fixed my home wiring issues quickly and professionally. I was impressed with their knowledge and fair pricing.",
      rating: 5,
      avatarUrl: "https://randomuser.me/api/portraits/men/32.jpg",
    },
    {
      name: "Sarah Johnson",
      role: "Business Owner",
      quote:
        "We hired them for our store's electrical renovation and they exceeded our expectations. Would definitely recommend them for commercial work.",
      rating: 4.5,
      avatarUrl: "https://randomuser.me/api/portraits/women/44.jpg",
    },
    {
      name: "Michael Davis",
      role: "Property Manager",
      quote:
        "Their team has been handling all electrical maintenance for our apartment complex. They're reliable, fast, and always available for emergencies.",
      rating: 5,
      avatarUrl: "https://randomuser.me/api/portraits/men/67.jpg",
    },
  ];

  return (
    <Box>
      {/* Hero Section */}
      <Hero />

      {/* About Section */}
      <Box className="py-16 bg-gray-50">
        <Container maxWidth="lg">
          <Grid container spacing={6} alignItems="center">
            <Grid item xs={12} md={6}>
              <Box className="p-4">
                <img
                  src={sample5}
                  alt="Electrician working"
                  className="rounded-lg shadow-md w-full"
                />
              </Box>
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography variant="h4" component="h2" className="font-bold">
                Your Trusted Electrical Service Provider
              </Typography>
              <Typography variant="body1" className="mb-6 text-gray-700">
                With over a decade of experience in the electrical industry,
                Davitt Electric has built a reputation for excellence in both
                residential and commercial electrical services. We pride
                ourselves on delivering safe, reliable, and code-compliant
                electrical solutions that exceed our customers' expectations
                every time.
              </Typography>
              <Typography variant="body1" className="mb-6 text-gray-700 py-4">
                Our team of licensed and insured electricians is dedicated to
                providing top-quality workmanship at competitive prices. From
                simple outlet installations to complex commercial projects, we
                approach every job with the same level of professionalism and
                attention to detail that has made us a trusted name in the
                community.
              </Typography>
              <Button
                variant="contained"
                color="primary"
                size="large"
                className="bg-gray-700 hover:bg-gray-800"
              >
                Learn More About Us
              </Button>
            </Grid>
          </Grid>
        </Container>
      </Box>

      {/* Services Section
      <Box className="py-16">
        <Container maxWidth="lg">
          <Box className="text-center mb-12">
            <Typography variant="h4" component="h2" className="font-bold mb-3">
              Our Services
            </Typography>
            <Typography variant="body1" className="text-gray-600 max-w-2xl mx-auto">
              We provide a wide range of electrical services for both residential and commercial clients, 
              ensuring safety, quality, and reliability in every project.
            </Typography>
          </Box>
          
          <Grid container spacing={4}>
            {services.map((service, index) => (
              <Grid item xs={12} sm={6} md={3} key={index}>
                <ServiceCard {...service} />
              </Grid>
            ))}
          </Grid>
          
        </Container>
      </Box> */}

      {/* Call to Action */}
      <Box
        className="py-20 text-white"
        sx={{
          backgroundImage: `linear-gradient(rgba(0,0,0,0.7), rgba(0,0,0,0.7)), url(${sample1})`,
        }}
      >
        <Container maxWidth="md" className="text-center">
          <Typography variant="h4" component="h2" className="font-bold mb-4">
            Need Professional Electrical Services?
          </Typography>
          <Typography variant="body1" className="mb-8 text-gray-100">
            Our licensed electricians are ready to help with any electrical need
            you have, from minor repairs to complete installations.
          </Typography>
          {/* <Button 
            variant="contained" 
            color="warning" 
            size="large"
            className="bg-yellow-500 hover:bg-yellow-600 px-8 py-3"
          >
            Get a Free Quote Today
          </Button> */}
        </Container>
      </Box>

      {/* Testimonials */}
      <Box className="py-16 bg-gray-50">
        <Container maxWidth="lg">
          <Box className="text-center mb-12">
            <Typography variant="h4" component="h2" className="font-bold mb-3">
              What Our Clients Say
            </Typography>
            <Typography
              variant="body1"
              className="text-gray-600 max-w-2xl mx-auto"
            >
              Don't just take our word for it. Here's what our satisfied
              customers have to say about our services.
            </Typography>
          </Box>

          <Grid container spacing={4}>
            {testimonials.map((testimonial, index) => (
              <Grid item xs={12} md={4} key={index}>
                <TestimonialCard {...testimonial} />
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>

      {/* Contact Section */}
      <Box className="py-16">
        <Container maxWidth="lg">
          <Grid container spacing={6}>
            <Grid item xs={12} md={6}>
              <Typography
                variant="h4"
                component="h2"
                className="font-bold mb-4"
              >
                Contact Us
              </Typography>
              <Typography variant="body1" className="mb-6 text-gray-700">
                Have questions or need to schedule a service? Reach out to us
                and our friendly team will assist you.
              </Typography>
              <ContactForm />
            </Grid>
            <Grid item xs={12} md={6}>
              <Box className="h-full flex flex-col justify-center p-4">
                <img
                  src={sample6}
                  alt="Electrician team"
                  className="rounded-lg shadow-md w-full"
                />
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </Box>
  );
};

export default Home;
